export class CancellationToken {
    public isCancellationRequested = false;
}
